import React, { useEffect, useState } from 'react';
import { IProduct } from '../../../Types/product';
import { useIPad, useMobile } from 'frontend/src/hooks/useMobile';
import { IconButton, Typography } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ProductCard from './ProductCard';

const useStyles = makeStyles((theme) => ({
  products: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  nextBackButton: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      fontSize: '2.5rem',
    },
  },
  backButton: { marginRight: theme.spacing(1) },
  nextButton: { marginLeft: theme.spacing(1) },
}));

export default function ProductPicker({
  options,
  selectedOption,
  onSelect,
}: {
  options: Array<IProduct>;
  selectedOption?: IProduct;
  onSelect: (is: string) => void;
}) {
  const mobile = useMobile();
  const iPad = useIPad();
  const classes = useStyles();
  const [firstProduct, setFirstProduct] = useState(0);

  const numProductsToDisplay = getIncrement(mobile, iPad);
  const lastProduct = firstProduct + numProductsToDisplay;

  function getIncrement(mobile: boolean, iPad: boolean) {
    let increment = 0;
    if (mobile) {
      increment = 1;
    } else if (iPad) {
      increment = 2;
    } else {
      increment = 4;
    }
    return increment;
  }

  function nextProducts() {
    setFirstProduct(firstProduct + numProductsToDisplay);
  }

  function previousProducts() {
    setFirstProduct(firstProduct - numProductsToDisplay);
  }

  useEffect(() => {
    if (options && selectedOption) {
      let selectedProductIndex = options.findIndex(
        (item) => item.id === selectedOption?.id,
      );
      const numToDisplay = getIncrement(mobile, iPad);
      const currentPage = Math.floor(selectedProductIndex / numToDisplay);
      setFirstProduct(currentPage * numToDisplay);
    }
  }, [options, selectedOption, mobile, iPad]);

  return (
    <>
      <div className={classes.products}>
        <div className={classes.nextBackButton}>
          <IconButton
            color="primary"
            className={classes.backButton}
            onClick={previousProducts}
            disabled={firstProduct > 0 ? false : true}
          >
            <ChevronLeftIcon />
          </IconButton>
        </div>
        {options && (
          <>
            {options
              ?.slice(firstProduct >= 0 ? firstProduct : 0, lastProduct)
              ?.map((product, i) => {
                return (
                  <ProductCard
                    product={product}
                    index={i}
                    isSelected={product.id === selectedOption?.id}
                    onSelect={onSelect}
                  />
                );
              })}
          </>
        )}
        <div className={classes.nextBackButton}>
          <IconButton
            color="primary"
            className={classes.nextButton}
            onClick={nextProducts}
            disabled={lastProduct >= options.length ? true : false}
          >
            <ChevronRightIcon />
          </IconButton>
        </div>
      </div>
      <Typography paragraph variant="h6">
        Products found: <b>{options.length}</b>
      </Typography>
    </>
  );
}
